module.exports = __webpack_public_path__ + "Simple-Line-Icons.f33df365d6d0255b586f.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/Simple-Line-Icons.eot?v=2.4.0
// module id = ../../../../../src/fonts/Simple-Line-Icons.eot?v=2.4.0
// module chunks = 2